import { ChainId } from '@pancakeswap/sdk'

export const SUPPORTED_CHAIN_IDS = [ChainId.KASPLEX_TESTNET, ChainId.IGRA, ChainId.KASPLEX_MAINNET] as const

export type SupportedChainId = (typeof SUPPORTED_CHAIN_IDS)[number]
